import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=27595615&scoped=true&"
import script from "./chat.vue?vue&type=script&lang=js&"
export * from "./chat.vue?vue&type=script&lang=js&"
import style0 from "./chat.vue?vue&type=style&index=0&lang=css&"
import style1 from "./chat.vue?vue&type=style&index=1&id=27595615&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27595615",
  null
  
)

export default component.exports